import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { BootController } from "./boot-control";

if (environment.production) {
  enableProdMode();
}

const init = () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, {
      applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.log(err));
};

init();

BootController.getbootControl()
  .watchReboot()
  .subscribe(() => init());
